import AppRoute from "models/AppRoute"

export type OutgoingInvoicesRouteType = "created" | "to-be-created"

interface IOutgoingInvoicesRouteParams {
    type: OutgoingInvoicesRouteType
}

const OutgoingInvoicesRoute = new AppRoute<IOutgoingInvoicesRouteParams>({
    route: "/outgoing-invoices/:type",
    navbar: true,
    authRequired: true,
})

export default OutgoingInvoicesRoute
